export default __webpack_public_path__ + "static/media/error.dacf1445.jpeg";